module.exports = __webpack_public_path__ + "img/LOGO.5ccd45aa.png";